(function () {
  'use strict';

  var dataEl = document.getElementById('cvrStoreData');
  if (!dataEl) return;
  var STORES = [];
  try { STORES = JSON.parse(dataEl.textContent || '[]'); } catch (e) {}

  var AREA_ORDER = ['北海道','東北','関東','中部','近畿','中国','四国','九州'];
  var state = { search: '', area: 'all', geo: false, userLat: null, userLng: null };

  function haversine(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var toRad = function (d) { return d * Math.PI / 180; };
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a = Math.sin(dLat/2)*Math.sin(dLat/2) + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng/2)*Math.sin(dLng/2);
    return 2 * R * Math.asin(Math.sqrt(a));
  }

  function withDistance(list) {
    if (!state.geo || state.userLat == null) return list;
    return list.map(function (s) {
      var d = null;
      if (s.lat != null && s.lng != null) d = haversine(state.userLat, state.userLng, parseFloat(s.lat), parseFloat(s.lng));
      var copy = {};
      for (var k in s) copy[k] = s[k];
      copy._dist = d;
      return copy;
    }).sort(function (a, b) {
      if (a._dist == null) return 1;
      if (b._dist == null) return -1;
      return a._dist - b._dist;
    });
  }

  function $(s) { return document.querySelector(s); }
  function $$(s) { return Array.from(document.querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); }

  function isOpenNow(hoursStr) {
    if (!hoursStr) return null;
    // "11:00 - 20:00" or "10:30-19:30" 形式を解析
    var m = String(hoursStr).match(/(\d{1,2}):(\d{2})\s*[-–~〜]\s*(\d{1,2}):(\d{2})/);
    if (!m) return null;
    var now = new Date();
    var nowMin = now.getHours() * 60 + now.getMinutes();
    var startMin = parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
    var endMin = parseInt(m[3], 10) * 60 + parseInt(m[4], 10);
    return nowMin >= startMin && nowMin < endMin;
  }

  function filtered() {
    var q = state.search.trim().toLowerCase();
    return STORES.filter(function (s) {
      if (state.area !== 'all' && s.area !== state.area) return false;
      if (q) {
        var hay = [s.name, s.area, s.prefecture, s.city, s.address].join(' ').toLowerCase();
        if (hay.indexOf(q) === -1) return false;
      }
      return true;
    });
  }

  function renderAreaFilters() {
    var counts = {};
    STORES.forEach(function (s) { counts[s.area] = (counts[s.area] || 0) + 1; });
    var html = '<button class="cvr-stores__chip" data-area="all" aria-pressed="' + (state.area === 'all') + '">全て <span class="cvr-stores__chip-count">' + STORES.length + '</span></button>';
    AREA_ORDER.forEach(function (a) {
      if (!counts[a]) return;
      html += '<button class="cvr-stores__chip" data-area="' + esc(a) + '" aria-pressed="' + (state.area === a) + '">' + esc(a) + ' <span class="cvr-stores__chip-count">' + counts[a] + '</span></button>';
    });
    document.getElementById('cvrStoreFilters').innerHTML = html;
  }

  function renderCard(s) {
    var openNow = isOpenNow(s.hours);
    var statusText = openNow == null ? '' : (openNow ? '営業中' : '営業時間外');
    var statusClass = openNow ? '' : 'cvr-store-card__status--closed';
    var statusHtml = statusText ? '<span class="cvr-store-card__status ' + statusClass + '">' + esc(statusText) + '</span>' : '';
    var distHtml = (state.geo && s._dist != null) ? '<span class="cvr-store-card__distance">約 ' + s._dist.toFixed(1) + ' km</span>' : '';
    var photoHtml = s.photo
      ? '<img src="' + esc(s.photo) + '" alt="' + esc(s.name) + '" loading="lazy">'
      : '<div class="cvr-store-card__image-placeholder">NO IMAGE</div>';
    var hoursLine = s.hours ? esc(s.hours) : '';
    if (s.holidays) hoursLine += (hoursLine ? '　／　' : '') + esc(s.holidays);
    var phoneHtml = s.phone
      ? '<a class="cvr-store-card__btn" href="tel:' + esc(String(s.phone).replace(/-/g,'')) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>電話</a>'
      : '';
    // 地図リンク: 登録URLがあればそれ、なければ住所検索URL
    var mapHref = s.map_url || (s.address ? 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(s.address) : '');
    var mapHtml = mapHref
      ? '<a class="cvr-store-card__btn cvr-store-card__btn--primary" href="' + esc(mapHref) + '" target="_blank" rel="noopener"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-7.5 8-13a8 8 0 1 0-16 0c0 5.5 8 13 8 13z"/><circle cx="12" cy="9" r="2.5"/></svg>地図を見る</a>'
      : '';
    return ''
      + '<article class="cvr-store-card">'
      +   '<div class="cvr-store-card__image">' + photoHtml + statusHtml + distHtml + '</div>'
      +   '<div class="cvr-store-card__body">'
      +     '<div class="cvr-store-card__area">' + esc(s.area || '') + (s.prefecture ? ' / ' + esc(s.prefecture) : '') + '</div>'
      +     '<h3 class="cvr-store-card__name">' + esc(s.name) + '</h3>'
      +     '<p class="cvr-store-card__address">'
      +       (s.zip ? '<span class="cvr-store-card__zip">〒' + esc(s.zip) + '</span><br>' : '')
      +       '<span class="cvr-store-card__addr-line">' + esc(s.address || '').replace(/\n/g, '<br>') + '</span>'
      +       (s.floor ? '<br><span class="cvr-store-card__floor">' + esc(s.floor) + '</span>' : '')
      +     '</p>'
      +     (hoursLine ? '<div class="cvr-store-card__hours"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 16 14"/></svg>' + hoursLine + '</div>' : '')
      +     '<div class="cvr-store-card__actions">' + phoneHtml + mapHtml + '</div>'
      +   '</div>'
      + '</article>';
  }

  function render() {
    var list = withDistance(filtered());
    var metaEl = document.getElementById('cvrStoreMeta');
    if (metaEl) metaEl.textContent = list.length + ' 件' + (state.geo ? '（近い順）' : '');
    var grid = document.getElementById('cvrStoreGrid');
    if (!grid) return;
    if (list.length === 0) {
      grid.innerHTML = '<div class="cvr-stores__empty"><strong>該当する店舗が見つかりませんでした</strong><span>検索条件を変更してお試しください</span></div>';
      return;
    }
    if (state.geo) {
      // 近い順表示時はエリア見出し無しのフラット表示
      grid.innerHTML = list.map(renderCard).join('');
    } else {
      var byArea = {};
      list.forEach(function (s) { (byArea[s.area] = byArea[s.area] || []).push(s); });
      var html = '';
      AREA_ORDER.forEach(function (a) {
        if (!byArea[a]) return;
        html += '<div class="cvr-stores__area-heading">' + esc(a) + '<span class="cvr-stores__area-count">' + byArea[a].length + '</span></div>';
        html += byArea[a].map(renderCard).join('');
      });
      grid.innerHTML = html;
    }
  }

  // --- Events ---
  var searchInput = document.getElementById('cvrStoreSearch');
  var searchClear = document.getElementById('cvrStoreSearchClear');
  var filters = document.getElementById('cvrStoreFilters');

  if (searchInput) {
    searchInput.addEventListener('input', function (e) {
      state.search = e.target.value;
      if (searchClear) searchClear.style.display = state.search ? 'block' : 'none';
      render();
    });
  }
  if (searchClear) {
    searchClear.addEventListener('click', function () {
      if (searchInput) searchInput.value = '';
      state.search = '';
      searchClear.style.display = 'none';
      render();
    });
  }
  if (filters) {
    filters.addEventListener('click', function (e) {
      var btn = e.target.closest('.cvr-stores__chip[data-area]');
      if (!btn) return;
      state.area = btn.dataset.area;
      renderAreaFilters();
      render();
    });
  }
  // 近い順ボタン (Geolocation API)
  var geoBtn = document.getElementById('cvrStoreGeo');
  var geoLabel = document.getElementById('cvrStoreGeoLabel');
  if (geoBtn) {
    geoBtn.addEventListener('click', function () {
      if (state.geo) {
        state.geo = false;
        geoBtn.setAttribute('aria-pressed', 'false');
        if (geoLabel) geoLabel.textContent = '近い順';
        render();
        return;
      }
      if (!navigator.geolocation) {
        alert('お使いのブラウザは位置情報に対応していません');
        return;
      }
      if (geoLabel) geoLabel.textContent = '取得中…';
      navigator.geolocation.getCurrentPosition(function (pos) {
        state.userLat = pos.coords.latitude;
        state.userLng = pos.coords.longitude;
        state.geo = true;
        geoBtn.setAttribute('aria-pressed', 'true');
        if (geoLabel) geoLabel.textContent = '近い順 ✓';
        render();
      }, function (err) {
        alert('位置情報を取得できませんでした: ' + err.message);
        if (geoLabel) geoLabel.textContent = '近い順';
      }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 });
    });
  }

  renderAreaFilters();
  render();
})();
